import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  background: #fff;
  top: 0;
  left: 434px;
  padding: 17px 24px 24px;

  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  width: 418px;
  z-index: 9;
  cursor: auto;
`;
export const Label = styled.h2`
  color: ${beam.font.primary};
  margin-top: 24px;
  margin-bottom: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
`;
export const LabelLight = styled(Label)`
  color: ${beam.placeholder.primary};
`;
export const Content = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const Tag = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 400;
  border-radius: 12px;
  background: ${beam.background.tag};
  color: ${beam.color.pureWhite};
  padding: 2px 10px 1px;
`;
export const Header = styled.h1`
  color: ${beam.font.primary};
  font-size: 20px;
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  align-items: center;
`;
export const CloseButton = styled.div`
  cursor: pointer;
  height: 14px;
  display: flex;
  align-items: flex-end;
  user-select: none;
`;
export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-bottom: 16px;

  /* borders/default-border */
  border-top: 1px solid ${beam.border.back};
`;
export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e9edf1;
  background: #fff;
  color: #838a91;
  font-size: 16px;
  padding: 5px 12px;
  width: 100%;
`;

export const Block = styled.div`
  background: #fff;
  padding: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 200px;
  min-height: 200px;
  z-index: 11;
`;

interface IItem {
  active: boolean;
}

export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;
interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 32px;
`;

export const WindowButtonImage = styled.img``;

export const BlueButton = styled.button`
  :disabled {
    cursor: default;
    opacity: 0.3;
  }
  color: ${beam.color.pureWhite};
  font-size: 14px;
  background: none;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 16px 7px;

  background: ${beam.color.primaryBlue};
  border-radius: 8px;
`;

export const DateDiv = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 16px;
  & .react-date-picker {
    & .react-date-picker__wrapper {
      border: none;
      height: 100%;
      display: flex;
      justify-content: center;
    }
    & .react-calendar {
      width: 400px !important;
      display: table-caption;
    }
  }
`;

export const WindowButton = styled(BlueButton)`
  user-select: none;

  background: ${beam.color.pureWhite};
  color: ${beam.font.primary};
  /* borders/default-border */
  border: 1px solid ${beam.border.back};
  box-sizing: border-box;
  border-radius: 8px;
`;
export const Icon = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;
export const ProfileImg = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 16px;
  object-fit: cover;
`;
export const StyledInput = styled.input`
  height: 32px;
  width: 100%;
  font-size: 14px;
  align-items: start;
  padding-left: 10px;
  padding-right: 8px;
  ::placeholder {
    color: #787878;
  }

  background: #ffffff;
  /* borders/light-border */
  border: 1px solid #d0dae3;
  box-sizing: border-box;
  border-radius: 8px;
`;
